import { TileContext } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamOverview/context'
import { OverviewTile } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamOverview/defaults'
import ByRole from 'app/frontend/base/pages/TeamDashboard/subpages/TeamOverview/components/tiles/RosterSummary/ByRole'
import { useMembersByRole } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamRoster/hooks'
import { RosterSetupContext } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamRoster/components/RosterSetup'

const rosterSummaryTile: OverviewTile = {
  type: 'Tile::RosterSummary',
  position: 'main',
  accessLevel: 'member',
  order: 0,
  config: {},
}

const GuildTeamRosterSummary = ({
  members,
}: {
  members?: wowaudit.TeamMembership[]
}) => {
  const {
    mains,
    mainsByRole,
    alts,
    altsByRole,
    membersWithOffspecs,
    offSpecsByRole,
  } = useMembersByRole(members ?? [])

  if (!members || members.length === 0) return null

  return (
    <RosterSetupContext.Provider
      value={{
        charactersById: {},
        mainByUser: {},
        userIdsWithDuplicateMains: [],
        sortedMembers: members,
        mains,
        alts,
        membersWithOffspecs,
        mainsByRole,
        altsByRole,
        offSpecsByRole,
      }}
    >
      <TileContext.Provider value={{ tile: rosterSummaryTile, index: 0 }}>
        <ByRole />
      </TileContext.Provider>
    </RosterSetupContext.Provider>
  )
}

export default GuildTeamRosterSummary
